import imgOne from './images/imgOne.jpg'
import imgTwo from './images/imgTwo.jpg'
import imgThree from './images/imgThree.jpg'
import imgFour from './images/imgFour.jpg'
import imgFive from './images/imgFive.jpg'

const homeData = [
    {
        id: 1,
        img: [imgOne, imgTwo, imgThree, imgFour, imgFive],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
    {
        id: 2,
        img: [imgFive, imgFour, imgOne, imgTwo, imgThree],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
    {
        id: 3,
        img: [imgFour, imgFive, imgOne, imgTwo, imgThree],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
    {
        id: 4,
        img: [imgThree, imgFour, imgTwo, imgOne, imgFive],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
    {
        id: 5,
        img: [imgFive, imgTwo, imgOne, imgThree, imgFour],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
    {
        id: 6,
        img: [imgTwo, imgOne, imgThree, imgFour, imgFive],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
    {
        id: 7,
        img: [imgThree, imgFour, imgTwo, imgOne, imgFive],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
    {
        id: 8,
        img: [imgOne, imgTwo, imgThree, imgFour, imgFive],
        name: 'Rockbridge, Ohio, US',
        designedBy: 'Designed by David Chipperfield',
        date: 'Dec 11 - 16',
        price: '$679',
        rating: '4.95'
    },
]

export default homeData